import { LatLng } from "leaflet";
import type { PropertySelectionRow, RealEstateSearchResult } from "../../types";

/**
 * 物件一覧の行の、地図上の位置（青ピンを立てる地点）。
 * 地番の情報（rawData）の座標を優先し、無ければ不動産検索結果の座標を使う。どちらも無ければ null
 */
export const getPropertyRowPosition = (
  row: PropertySelectionRow
): LatLng | null => {
  const lat =
    row.rawData?.lat ?? (row as Partial<RealEstateSearchResult>).latitude;
  const lng =
    row.rawData?.lng ?? (row as Partial<RealEstateSearchResult>).longitude;
  if (
    typeof lat !== "number" ||
    typeof lng !== "number" ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng)
  ) {
    return null;
  }
  return new LatLng(lat, lng);
};

/** 同じ地点とみなす緯度経度の差（約1cm）。数値の丸めの差だけ許す */
export const SAME_POSITION_MARGIN = 1e-7;

/**
 * 地図のピンの地点にある、物件一覧の行の id。無ければ null。
 * 検索結果・保存した物件リストなどのピンは、一覧の行と同じ座標に立っているので、座標で引ける
 */
export const findPropertyRowIdAtPosition = (
  rows: PropertySelectionRow[],
  position: LatLng
): number | null => {
  const row = rows.find((r) =>
    getPropertyRowPosition(r)?.equals(position, SAME_POSITION_MARGIN)
  );
  return row?.id ?? null;
};
